import React from 'react';
import { HomePage, HousePage, CharacterPage, BooksPage, BookItem, ErrorPage } from '../../pages';
import { Route, Switch } from 'react-router-dom';

const App = () => (
  <div className='app'>
    <Switch>
      <Route path='/' exact component={HomePage} />
      <Route path='/characters' component={CharacterPage} />
      <Route path='/houses' component={HousePage} />
      <Route path='/books' exact component={BooksPage} />
      <Route path='/books/:id' render={
        ({ match: { params: { id } } }) => {
          return <BookItem itemId={id} />
        }
      } />
      <Route path="*" component={ErrorPage} />
    </Switch>
  </div>
)

export default App